import React from 'react'
import DiamondTransferCreateContainer from "containers/panel/reseller/diamond-transfer-create-container"

const CreateDiamondTransferPage = () => {
  return (
    <DiamondTransferCreateContainer/>
  )
}

export default CreateDiamondTransferPage